import { NextSeo } from "next-seo"
import { memo } from "react"

export const seoKeys = {
  // NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
}
export type SeoKey = keyof typeof seoKeys

for (const key in seoKeys) {
  seoKeys[key] = encodeURIComponent(
    seoKeys[key]
      .replace(/\/\[.+/, "")
      .replace("/", "")
      .replace(/-/g, " ")
  )
}
export interface SeoMetadataWithImage {
  title: string
  description: string
  keywords: string
  image?: { alt: string; imageUrl: string }
}

export const emptySeo: SeoMetadataWithImage = {
  title: " ",
  description: "",
  keywords: "",
}

type SeoMetaDataProps = { data: SeoMetadataWithImage | null }

const SeoMetaData = ({ data }: SeoMetaDataProps) => (

  <>
    {data && (
      <NextSeo
        title={data.title}
        description={data.description || ""}
        additionalMetaTags={[
          { name: "title", content: data.title },
          { name: "keywords", content: data.keywords },
          { name: "description", content: data.description },
        ]}
        openGraph={{
          title: data.title,
          description: data.description || "",
        }}
      />
    )}
  </>
)

export default memo(SeoMetaData)
